// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2XQjD","notes":"Notes_notes__2dXuF","note":"Notes_note__3imai","markdown":"Notes_markdown__jSaRi"};